//*Variables para fechas de corte de tiendas
var dateStart = Date;
var dateEnd = Date;

function getNumberOfDays(num = 1) {
  return 24 * 60 * 60 * 1000 * num;
}

function getStartDate(min) {
  const startDate = new Date();
  startDate.setTime(startDate.getTime() - getNumberOfDays(min));
  return startDate.toISOString();
}

function weekCut() {
  var res = [];
  var a = new Date();
  var days = new Array(7);
  days[0] = "Sunday";
  days[1] = "Monday";
  days[2] = "Tuesday";
  days[3] = "Wednesday";
  days[4] = "Thursday";
  days[5] = "Friday";
  days[6] = "Saturday";
  var r = days[a.getDay()];

  switch (r) {
    case "Saturday":
      dateStart = getStartDate(7);
      dateEnd = getStartDate(1);
      break;
    case "Sunday":
      dateStart = getStartDate(8);
      dateEnd = getStartDate(2);
      break;
    case "Monday":
      dateStart = getStartDate(9);
      dateEnd = getStartDate(3);
      break;
    case "Tuesday":
      dateStart = getStartDate(10);
      dateEnd = getStartDate(4);
      break;
    case "Wednesday":
      dateStart = getStartDate(11);
      dateEnd = getStartDate(5);
      break;
    case "Thursday":
      dateStart = getStartDate(12);
      dateEnd = getStartDate(6);
      break;
    case "Friday":
      dateStart = getStartDate(13);
      dateEnd = getStartDate(7);
      break;

    default:
      break;
  }

  res.push(dateStart, dateEnd);
  return res;
}

export default weekCut;
